export default function PeopleGroup({ color = "#3E3E3E", width = "24", height = "24" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.3271 9.9364C19.9855 10.5948 19.9855 11.6622 19.3271 12.3205C18.6688 12.9789 17.6013 12.9789 16.943 12.3205C16.2846 11.6622 16.2846 10.5948 16.943 9.9364C17.6013 9.27804 18.6688 9.27804 19.3271 9.9364"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8354 6.92705C14.8492 7.94078 14.8492 9.58437 13.8354 10.5981C12.8217 11.6118 11.1781 11.6118 10.1644 10.5981C9.15062 9.58438 9.15062 7.94079 10.1644 6.92705C11.1781 5.91331 12.8217 5.91331 13.8354 6.92705"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.05709 9.9364C7.71545 10.5948 7.71545 11.6622 7.05709 12.3205C6.39873 12.9789 5.33133 12.9789 4.67297 12.3205C4.01461 11.6622 4.01461 10.5948 4.67297 9.9364C5.33133 9.27804 6.39874 9.27804 7.05709 9.9364"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1666 17.8333V16.92C21.1666 15.7692 20.2341 14.8367 19.0833 14.8367H18.4158"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.83325 17.8333V16.92C2.83325 15.7692 3.76575 14.8367 4.91659 14.8367H5.58409"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4492 17.8334V16.4992C16.4492 14.8884 15.1434 13.5825 13.5325 13.5825H10.4667C8.85588 13.5825 7.55005 14.8884 7.55005 16.4992V17.8334"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
